import { ButtonLink } from '@toggle/design-system';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';

import styles from './Footer.module.scss';

export interface FooterProps {
  hasScroll: boolean;
  onClose: () => void;
}

export const Footer = ({ hasScroll, onClose }: FooterProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();

  const handleNavigateToAlerts = () => {
    onClose();
    navigate(appPaths.alerts);
  };

  return (
    <div
      className={clsx(styles.footerRoot, {
        [styles.hasScroll]: hasScroll,
      })}
    >
      <p className={styles.footerText}>{t('dropdown.footerText')}</p>
      <ButtonLink
        className={styles.styledButtonLink}
        label={t('dropdown.viewPastNotifications')}
        onClick={handleNavigateToAlerts}
      />
    </div>
  );
};
